export const getEmbeddFromUrl = (url, apiKey) => {
  const id = url?.match(/[-\w]{25,}/);
  return "http://45.93.92.128:3005/image/" + id;
  // return `https://www.googleapis.com/drive/v2/files/${id}?key=${apiKey}&alt=media`;
  // return "https://lh5.googleusercontent.com/d/" + id + "=w300-h300-p";
  // return "https://drive.google.com/thumbnail?authuser=0&sz=w300&id=" + id;
};
